import src from "IMAGE";
export default { src, width: 5460, height: 1224, blurWidth: 0, blurHeight: 0};
